import styled, { css } from "styled-components";

const ExpiredBonusItemWrapper = styled.div``;

const BonusItemWrapper = styled.div`
	display: flex;
	padding: 5px 0px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	align-self: stretch;
	border-radius: 15px;
	background: linear-gradient(180deg, rgba(192, 192, 192, 0.2) 0%, rgba(91, 91, 91, 0.2) 100%);
	margin-bottom: 10px;
	width: 100%;
	min-width: 274px;
`;

const ItemHeader = styled.div`
	display: flex;
	padding: 5px 10px;
	justify-content: center;
	align-items: center;
	align-self: stretch;
	background: linear-gradient(180deg, rgba(199, 199, 199, 0.2) 0%, rgba(139, 136, 143, 0.2) 100%);
	color: rgba(252, 252, 252, 0.4);
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.3px;
	border-radius: 15px 15px 0px 0px;
	opacity: 0.4;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 14px;
	}
`;

const ItemContent = styled.div`
	display: flex;
	height: 40px;
	padding: 5px 10px;
	justify-content: space-between;
	align-items: center;
	align-self: stretch;
	background: linear-gradient(180deg, rgba(199, 199, 199, 0.2) 0%, rgba(139, 136, 143, 0.2) 100%);
`;

const ContentInfo = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	color: rgba(252, 252, 252, 0.4);
	font-size: 10px;
	line-height: 12px;
	letter-spacing: 0.3px;

	@media (min-width: 768px) {
		font-size: 12px;
	}
`;

const InfoTitle = styled.div`
	color: rgba(252, 252, 252, 0.4);
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

const Info = styled.div`
	color: rgba(252, 252, 252, 0.4);
	font-size: 14px;
	font-weight: 700;
	line-height: 20px;
	letter-spacing: 0.3px;
	padding-left: 3px;

	@media (min-width: 768px) {
		font-size: 16px;
	}
`;

const WagerInfo = styled.div`
	display: flex;
	height: 20px;
	justify-content: center;
	align-items: center;
	gap: 12px;
	border-radius: 50px;
	background: linear-gradient(180deg, #aeaeae 0%, #777475 100%);
	color: rgba(252, 252, 252, 0.4);
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	width: 55px;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DetailsButton = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	align-items: center;
	border-top: 1px solid #e4e4e4;
	padding-top: 5px;
	svg {
		width: 14px;
		height: 14px;
		path {
			stroke: #e4e4e4;
		}
	}

	${({ rotate }) =>
		rotate &&
		css`
			svg {
				transform: rotate(180deg);
				animation: rotate 0.1s;
			}
		`}
`;

const ButtonText = styled.div`
	display: flex;
	color: #e4e4e4;
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	min-width: 42px;
	justify-content: flex-end;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const DateWrapper = styled.div`
	display: flex;
	align-items: center;
	gap: 5px;
	padding: 10px;
	justify-content: center;
	align-self: stretch;
	width: 100%;
`;

const Date = styled.div`
	align-items: center;
	display: flex;
	flex: 1 0 0;
	color: #a0a3bd;
	text-align: center;
	font-size: 10px;
	font-weight: 600;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;

	@media (min-width: 768px) {
		font-size: 12px;
		line-height: 20px;
	}
`;

const Detail = styled.div`
	display: flex;
	padding: 10px;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	color: var(--main-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	justify-content: center;
	opacity: 0.4;

	@media (min-width: 768px) {
		font-size: 12px;
	}
`;

const DetailWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	align-items: center;
	justify-content: center;
`;

const ExpiredInfoHeader = styled.div`
	display: flex;
	padding: 4px 50px;
	justify-content: center;
	align-items: center;
	gap: 10px;
	align-self: stretch;
	border-radius: 15px 15px 0px 0px;
	background: linear-gradient(180deg, #f0052f 0%, #940136 100%);
	color: #f7f7fc;
	font-size: 12px;
	font-weight: 400;
	line-height: 16px;
	letter-spacing: 0.3px;
	width: 100%;
	min-width: 274px;
`;

export {
	BonusItemWrapper,
	ButtonText,
	ContentInfo,
	Date,
	DateWrapper,
	Detail,
	DetailWrapper,
	DetailsButton,
	ExpiredBonusItemWrapper,
	ExpiredInfoHeader,
	Info,
	InfoTitle,
	ItemContent,
	ItemHeader,
	WagerInfo,
};
